<div *ngIf="!(failureResponse$ | async)" class="hitmap-container flex flex-col">
  <div #reportsContainer id="reportsContainer" class="main-content" [style.display]="dataLoaded ?'block':'none'"
       [style.visibility]="dataLoaded ? 'visible' : 'hidden'">
  </div>
  <div *ngIf="!dataLoaded" class="empty-content flex flex-col flex flex-col justify-center items-center flex-1-0-100">
    <div class="text-container">
      <div class="svg-container" [ngStyle]="loadingPercentage">
        <img src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/icon.png"
             alt="">
      </div>
      <h1>Loading your Dashboard...</h1>
      <div class="text">Please wait while we load the data for your chosen period and settings. This may take up to 60
        seconds depending on the size of the data.
      </div>
      <div class="instruction">You can navigate ITP and access your Orbitax Solutions from the left-hand menu at any
        time
      </div>
    </div>
  </div>
</div>

<div class="empty-content flex flex-col justify-center items-center flex-1-0-100" *ngIf="(failureResponse$ | async)">
  <div class="text-container">
    <div class="svg-container" style="background: linear-gradient(to top, red 100%, #eee 0%);">
      <img src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/icon.png"
           alt="">
    </div>
    <h1>Sorry, there was an error...</h1>
    <div class="text">We couldn't load your data as the query exceeded the data limit. Please adjust the settings to
      reduce the size of the query, and try again.
    </div>
  </div>
</div>
